<div class="client-notes-modal" [class.maximized]="isMaximized">
  <div class="modal-header">
    <h2 mat-dialog-title>
      Client Notes
      <span *ngIf="data.clientName" class="client-name">- {{ data.clientName }}</span>
    </h2>
    <div class="header-actions">
      <button mat-icon-button (click)="onClose()" title="Close">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <mat-dialog-content style="max-height: 80vh;">
    <div *ngIf="isLoading" class="loading-container">
      <mat-spinner diameter="40"></mat-spinner>
      <p>Loading notes...</p>
    </div>

    <form [formGroup]="notesForm" *ngIf="!isLoading">
      <div class="editor-container">
        <editor
          #editor
          formControlName="notes"
          [init]="tinymceInit"
          [disabled]="isSubmitting">
        </editor>
      </div>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="onClose()" [disabled]="isSubmitting">Close</button>
    <button 
      mat-raised-button 
      color="primary" 
      (click)="onSave()" 
      [disabled]="isSubmitting || !hasChanges()">
      <span *ngIf="!isSubmitting">Save</span>
      <span *ngIf="isSubmitting">Saving...</span>
    </button>
  </mat-dialog-actions>
</div>
